import type { PartialSettingsNotifications } from "../user-preferences-notifications.type";
import type { UserPreferencesNotificationsSectionActionsProps } from "./user-preferences-notifications-section-actions.type";
import type { UserPreferencesNotificationsMenuItemOptions } from "../user-preferences-notifications-dropdown";

import { useUserPreferencesNotificationsDropdownBuilder } from "../user-preferences-notifications-dropdown";
import { useUserPreferencesNotificationsContext } from "../user-preferences-notifications.context";
import { getSettingChannelsFromAction } from "../user-preferences-notifications.helper";

export const useUserPreferencesNotificationsSectionActions = ({
  notifications,
}: UserPreferencesNotificationsSectionActionsProps) => {
  const { defaultSettings, onSettingsChange } =
    useUserPreferencesNotificationsContext();
  const { buildAction, buildDivider } =
    useUserPreferencesNotificationsDropdownBuilder();

  const menuItems = [
    buildAction("activate"),
    buildAction("disable"),
    buildDivider(),
    buildAction("reset"),
  ];

  const onMenuItemClick = ({
    action,
  }: UserPreferencesNotificationsMenuItemOptions) => {
    const newSettings: PartialSettingsNotifications = {};

    notifications.forEach((notification) => {
      const defaultChannels = defaultSettings?.[notification.slug];
      const newValue = getSettingChannelsFromAction(action, defaultChannels);
      newSettings[notification.slug] = newValue;
    });

    onSettingsChange(newSettings);
  };

  return {
    menuItems,
    onMenuItemClick,
  };
};
